import React from 'react';
import styles from './UI.module.css';

/* ── Page Header (dark navy, used on inner pages) ─────────────────── */
export function PageHeader({ crumb, title, desc, statNum, statLbl }) {
  return (
    <div className={styles.pageHeader}>
      <div className={`wrap ${styles.phInner}`}>
        <div>
          {crumb && (
            <nav className={styles.crumb} aria-label="Breadcrumb">
              <a href="/">Home</a>
              <span aria-hidden="true">/</span>
              <span aria-current="page">{crumb}</span>
            </nav>
          )}
          <h1>{title}</h1>
          {desc && <p>{desc}</p>}
        </div>
        {statNum && (
          <div className={styles.stat}>
            <div className={styles.statNum}>{statNum}</div>
            <div className={styles.statLbl}>{statLbl}</div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Eyebrow label ────────────────────────────────────────────────── */
export function Eyebrow({ children, light, green }) {
  const cls = [styles.eyebrow, light && styles.light, green && styles.green].filter(Boolean).join(' ');
  return <div className={cls}>{children}</div>;
}

/* ── Section heading block ────────────────────────────────────────── */
export function SectionHead({ eyebrow, eyeLight, title, sub, light, center, maxWidth = '540px' }) {
  return (
    <div style={{ maxWidth, marginBottom: sub ? 0 : 40 }}>
      {eyebrow && <Eyebrow light={eyeLight}>{eyebrow}</Eyebrow>}
      <h2 className={`sh ${light ? 'light' : ''} ${center ? styles.center : ''}`}>{title}</h2>
      {sub && <p className={`sub ${light ? 'light' : ''}`}>{sub}</p>}
    </div>
  );
}

/* ── Tag ──────────────────────────────────────────────────────────── */
export function Tag({ label, variant }) {
  return <span className={`tag ${variant ? variant : ''}`}>{label}</span>;
}

/* ── Dimension tile (dark bg) ────────────────────────────────────── */
export function DimTile({ n, label }) {
  return (
    <div className="dim-tile">
      <span className="dim-n">{n}</span>
      <span className="dim-t">{label}</span>
    </div>
  );
}

/* ── Classification band ─────────────────────────────────────────── */
export function ClassBand({ score, name, desc, variant }) {
  return (
    <div className={`cc ${variant}`}>
      <div className="cc-sc">{score}</div>
      <div className="cc-nm">{name}</div>
      <div className="cc-ds">{desc}</div>
    </div>
  );
}

/* ── Tech feature card (dark bg) ────────────────────────────────── */
export function TechCard({ icon, title, desc }) {
  return (
    <div className={styles.techCard}>
    <div className={styles.techIco}>
        <img src={icon} alt={title} width={24} height={24} />
      </div>
      <h4>{title}</h4>
      <p>{desc}</p>
    </div>
  );
}

/* ── Capability card ─────────────────────────────────────────────── */
export function CapCard({ num, icon, title, desc, bullets, tags }) {
  return (
    <div className={styles.capCard}>
      <div className={styles.capNum}>{num}</div>
      <div className={styles.capIco}>{icon}</div>
      <h3>{title}</h3>
      <p>{desc}</p>
      {bullets && (
        <ul className={styles.capList}>
          {bullets.map((b, i) => <li key={i}>{b}</li>)}
        </ul>
      )}
      {tags && (
        <div className="tags" style={{ marginTop: 12 }}>
          {tags.map((t, i) => <Tag key={i} label={t.l} variant={t.c} />)}
        </div>
      )}
    </div>
  );
}

/* ── Marquee band ────────────────────────────────────────────────── */
export function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className={styles.marqueeBand} aria-hidden="true">
      <div className={styles.marqueeTrack}>
        {doubled.map((item, i) => (
          <span key={i} className={styles.mi}>{item}</span>
        ))}
      </div>
    </div>
  );
}

/* ── Impact strip item ───────────────────────────────────────────── */
export function ImpactItem({ icon, num, label, desc }) {
  return (
    <div className={styles.ic}>
      <div className={styles.icIco}>
        <img src={icon} width={24} height={24} />
      </div>
      <div className={styles.icNum}>{num}</div>
      <div className={styles.icLbl}>{label}</div>
      <div className={styles.icDesc}>{desc}</div>
    </div>
  );
}

/* ── Use-case card ───────────────────────────────────────────────── */
export function UCCard({ icon, title, desc, span }) {
  return (
    <div className={`${styles.ucCard} ${span ? styles.ucSpan : ''}`}>
      <div className={styles.ucIco}>
        <img src={icon} alt={title} width={24} height={24} />
      </div>
      <div>
        <h3>{title}</h3>
        <p>{desc}</p>
      </div>
    </div>
  );
}
